import React, { useState, useEffect } from 'react';
import cx from 'classnames';

import { ExternalFormWidgetContext } from '..';
import styles from '../style.module.scss';
import get from 'lodash/get';
import size from 'lodash/size';


export const MarketoFormView = ({ form, uid }) => {
  const context = React.useContext(ExternalFormWidgetContext);
  const formContainerRef = React.useRef(null);
  const widgetContextRef = React.useRef(null);

  const [state, setState] = useState({
    loading: false,
    scriptLoaded: false,
    formloaded: false
  });

  var formId = get(form.configuration, 'formId', null);
  var munchkinId = get(form.configuration, 'munchkinId', null);
  var domain = get(form.configuration, 'domain', null);

  const handleFormSubmit = (contactRequest) => {
    const widgetContext = widgetContextRef.current;
    if (widgetContext.onFormSubmit) {
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
      return;
    }
  }

  const appendScript = (baseUrl) => {
    if (window.MktoForms2) {
      return;
    }

    const script = document.createElement("script");
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    script.onload = () => {
      loadForm();
    }

    document.body.appendChild(script);
  }

  useEffect(() => {
    widgetContextRef.current = context;
  }, [context]);

  useEffect(() => {
    if (!window.MktoForms2) {
      appendScript(domain);
    } else {
      loadForm();
    }
  }, [context.onFormSubmit]);

  const loadForm = () => {
    if (!window.MktoForms2 || !context.onFormSubmit) {
      return;
    }

    window.MktoForms2.whenReady(function (form) {
      setState((state) => {
        return {
          ...state,
          loading: false,
        }
      })
    });

    const loadedForm = window.MktoForms2.getForm(formId);
    if (loadedForm) {
      destroyForm();
      renderForm(loadedForm);
    } else {
      window.MktoForms2.loadForm(domain, munchkinId, formId, function (form) {
        destroyForm();
        renderForm(form);
      });
    }
  }


  const renderForm = (form) => {
    if(!form) {
      return;
    }

    const formElement = document.createElement("form");

    const rendered = form.render(formElement);

    if (size(rendered) == 0) {
      return;
    }

    window.postMessage({
      type: "cleverstory:marketo:form:loaded",
      payload: {
        formId: formId
      }
    }, '*');

    rendered[0].setAttribute("id", "marketo_" + new Date().getTime());
    formContainerRef.current.appendChild(rendered[0]);

    form.onSubmit(function () {
    });

    form.onSuccess(function (values, followUpUrl) {
      var vals = form.vals();

      var email = get(vals, 'Email');
      var firstName = get(vals, 'FirstName') || null;
      var lastName = get(vals, 'LastName') || null;
      var title = get(vals, 'Title') || null;
      var company = get(vals, 'Company') || null;
      var phone = get(vals, 'Phone') || null;

      var contactRequest = {
        email: email.toString(),
        firstName: firstName,
        lastName: lastName,
        title: title,
        company: company,
        workphone: phone,
        formSource: 'marketo',
      };
      
      handleFormSubmit(contactRequest);
      return false;
    });
  }

  const destroyForm = () => {
    formContainerRef.current.innerHTML = "";
  }

  return (
    <div key={uid} className={cx(styles.externalForm, { [styles.loadingMarketoForm]: state.loading })}>
      {state.loading && <div> Loading Marketo Form .... </div>}
      <div ref={formContainerRef}></div>
    </div>
  )
};
